export const REVIEW_ONLY_FIELD_IDS = ['EntityType'];

import { SNOWAttributeType } from '@amzn/snow-nxt-workflow-service-typescript-client';

export const SYSTEM_FIELD_IDS = ['Region', 'EntityName', 'EntityType'];

/**
 * Attribute types that must never appear in the Layout Editor. Global attributes
 * are shared across workflow executions and Derived attributes are computed from
 * other task responses at runtime, so neither is user-editable in the portal.
 */
export const EXCLUDED_ATTRIBUTE_TYPES = new Set<string>([
	SNOWAttributeType.GLOBAL_ATTRIBUTE,
	SNOWAttributeType.DERIVED_ATTRIBUTE,
]);

/** Returns true if the given attribute should be surfaced in the Layout Editor. */
export function isLayoutEligibleAttribute(attr: { attributeType?: string }): boolean {
	return !attr.attributeType || !EXCLUDED_ATTRIBUTE_TYPES.has(attr.attributeType);
}

export const LAYOUT_EDITOR_HELP_PANEL = {
	title: 'Portal Layout Editor',
	description: 'Customize how the requirement portal appears to users who execute this workflow.',
	steps: 'Wizard steps that group related fields together. Add, remove, or rename steps as needed. Each step becomes a page in the execution wizard.',
	sections: 'Containers within a step that visually group fields. Configure columns (1, 2, or 3) for each section to control the form density.',
	fields: {
		available: 'Fields from the workflow definition not yet placed in the layout. Use search to find specific fields.',
		addToSection: 'Click the "+ Section Name" button to place a field.',
		reorder: 'Drag fields within a section to change their order.',
		fullWidth: 'Toggle to make a field span the entire section width (useful for text areas or lists).',
		remove: 'Click X to return a field to the available pool.',
	},
	preview: 'Click "Preview" to see exactly how the portal will appear to executors. For UPDATE workflows, the review step shows a diff table.',
	additionalFields: 'Any fields not placed in the layout will automatically appear in an "Additional Fields" step during execution. This ensures no required data is missed.',
	saving: [
		'Layouts are persisted on the workflow definition via the workflow service.',
		'Saved layouts apply to every user who executes this workflow.',
	],
	links: [{ href: '#/manageWorkflows', text: 'Back to Manage Workflows' }],
};

export const NO_WORKFLOW_SELECTED = {
	title: 'No Workflow Selected',
	message: 'Navigate here from Manage Workflows by selecting a workflow and choosing "Customize Portal" from the Actions menu.',
	buttonText: 'Back to Manage Workflows',
	buttonHref: '#/manageWorkflows',
};
